import { Button, Stack, Text, XStack } from '@my/ui'
import React, { useEffect, useState } from 'react'

interface DurationSelectorProps {
  localDuration: number | null
  onDurationSelect: (value: number | null) => void
}

export function DurationSelector({
  localDuration,
  onDurationSelect,
}: DurationSelectorProps) {
  const basicDurationOptions = [
    { label: 'None', value: null },
    { label: '5m', value: 5 },
    { label: '15m', value: 15 },
    { label: '30m', value: 30 },
    { label: '1h', value: 60 },
  ] as const

  const extendedDurationOptions = [
    { label: '1.5h', value: 90 },
    { label: '2h', value: 120 },
    { label: '2.5h', value: 150 },
    { label: '3h', value: 180 },
    { label: '3.5h', value: 210 },
    { label: '4h', value: 240 },
    { label: '4.5h', value: 270 },
    { label: '5h', value: 300 },
    { label: '5.5h', value: 330 },
    { label: '6h', value: 360 },
    { label: '6.5h', value: 390 },
    { label: '7h', value: 420 },
    { label: '8h', value: 480 },
  ] as const

  const [showExtended, setShowExtended] = useState(false)

  // Auto-expand if a longer duration is selected
  useEffect(() => {
    const isExtendedDurationSelected = localDuration !== null &&
      extendedDurationOptions.some(option => option.value === localDuration)

    if (isExtendedDurationSelected) {
      setShowExtended(true)
    }
  }, [localDuration])

  const isOptionSelected = (option: { value: number | null }) => {
    if (option.value === null && localDuration === null) {
      return true
    }
    return option.value === localDuration
  }

  const allOptions = showExtended
    ? [...basicDurationOptions, ...extendedDurationOptions]
    : basicDurationOptions

  return (
    <Stack>
      <Text fontSize="$7" fontWeight="bold">Duration <Text color="$color7" fontSize="$4" fontWeight="normal">(How long will this take?)</Text></Text>
      <XStack flexWrap="wrap"
      //backgroundColor="$color4"
      //borderRadius="$4"
      justifyContent="center"
      width="100%"
      marginTop="$3">
        {allOptions.map((option) => (
          <Button
            unstyled
            borderRadius="$4"
            cursor="pointer"
            //paddingHorizontal={15}
            margin="$0.5"
            width={55}
            paddingVertical="$2.5"
            key={option.label}
            fontSize="$3"
            fontWeight="bold"
            height="$4"
            size="$2.5"
            alignItems="center"
            justifyContent="center"
            backgroundColor={
              isOptionSelected(option) ? '$accentColor' : '$color4'
            }
            color={
              isOptionSelected(option) ? '$color1' : '$color7'
            }
            onPress={() => onDurationSelect(option.value)}
            hoverStyle={{ scale: 1.05, animation: "medium" }}
          >
            {option.label}
          </Button>
        ))}
        {!showExtended && (
          <Button
            unstyled
            borderRadius="$4"
            cursor="pointer"
            margin="$0.5"
            width={55}
            paddingVertical="$2.5"
            fontSize="$3"
            fontWeight="bold"
            height="$4"
            size="$2.5"
            alignItems="center"
            justifyContent="center"
            backgroundColor="$color4"
            color="$color7"
            onPress={() => setShowExtended(true)}
            hoverStyle={{ scale: 1.05, animation: "medium" }}
          >
            More
          </Button>
        )}
      </XStack>
      {/* {showCustomDuration && (
        <XStack
          alignSelf="flex-end"
          backgroundColor="$color4"
          borderRadius="$4"
          borderWidth={3}
          marginTop="$3"
          paddingHorizontal="$3"
          paddingVertical="$2"
          alignItems="center"
          borderColor="$accentColor"
        >
          <Input
            placeholder="0"
            value={customDuration}
            onChangeText={onCustomDurationChange}
            inputMode="numeric"
            width={30}
            unstyled
            textAlign="right"
            fontSize="$4"
            placeholderTextColor="$color12"
          />
          <Text color="$color12" marginLeft="$2">minutes</Text>
        </XStack>
      )} */}
    </Stack>
  )
}
